import { render, staticRenderFns } from "./LoaderTable.vue?vue&type=template&id=d65b1c28&scoped=true"
import script from "./LoaderTable.vue?vue&type=script&lang=js"
export * from "./LoaderTable.vue?vue&type=script&lang=js"
import style0 from "./LoaderTable.vue?vue&type=style&index=0&id=d65b1c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65b1c28",
  null
  
)

export default component.exports